import { ERROR_CODES, METHOD_STATUSES } from "../constants";
import { ErrorResult } from "../types";

class SdkError extends Error implements ErrorResult {
    public readonly code: ERROR_CODES;

    public readonly status = METHOD_STATUSES.ERROR;

    constructor(code: ERROR_CODES, message = "") {
        super(message);
        this.code = code;
    }
}

export default SdkError;
